__turbopack_context__.v({
  "byline": "BlockTestimonialCarousel-module-scss-module__kI40KW__byline",
  "carousel": "BlockTestimonialCarousel-module-scss-module__kI40KW__carousel",
  "divider": "BlockTestimonialCarousel-module-scss-module__kI40KW__divider",
  "flushBottom": "BlockTestimonialCarousel-module-scss-module__kI40KW__flushBottom",
  "flushTop": "BlockTestimonialCarousel-module-scss-module__kI40KW__flushTop",
  "heading": "BlockTestimonialCarousel-module-scss-module__kI40KW__heading",
  "headingLockup": "BlockTestimonialCarousel-module-scss-module__kI40KW__headingLockup",
  "headline": "BlockTestimonialCarousel-module-scss-module__kI40KW__headline",
  "icon": "BlockTestimonialCarousel-module-scss-module__kI40KW__icon",
  "inner": "BlockTestimonialCarousel-module-scss-module__kI40KW__inner",
  "navigation": "BlockTestimonialCarousel-module-scss-module__kI40KW__navigation",
  "navigationButton": "BlockTestimonialCarousel-module-scss-module__kI40KW__navigationButton",
  "navigationButtonIcon": "BlockTestimonialCarousel-module-scss-module__kI40KW__navigationButtonIcon",
  "quote": "BlockTestimonialCarousel-module-scss-module__kI40KW__quote",
  "root": "BlockTestimonialCarousel-module-scss-module__kI40KW__root",
  "slide": "BlockTestimonialCarousel-module-scss-module__kI40KW__slide",
  "slides": "BlockTestimonialCarousel-module-scss-module__kI40KW__slides",
});
